import React from 'react'

const getCurrentTimestamp = (timestamps, time) => {
  return timestamps.find(timestamp => time >= timestamp.start_seconds &&
    time <= timestamp.finish_seconds
  )
}

export const NewPlayer = props => {
  const { vlog, timestamps, start = 0, autoPlay = false } = props;
  const [playerState, setPlayerState] = React.useState(null)
  const [player, setPlayer] = React.useState(null)
  const iframeRef = React.useRef(null)
  const [ready, setReady] = React.useState(false)
  const [currentTimestamp, setCurrentTimestamp] = React.useState(null)
  const [showCaptions, setShowCaptions] = React.useState(true)

  const loadPlayer = () => {
    window.onYouTubeIframeAPIReady = () => {
      const newPlayer = new window.YT.Player('cushvlog-player', {
        width: window.visualViewport.width,
        height: window.visualViewport.height
      })
      newPlayer.addEventListener('onReady', () => {
        setReady(true)
        newPlayer.seekTo(0.1)
        newPlayer.addEventListener('onStateChange', evt => setPlayerState(evt.data))
      })

      setPlayer(newPlayer)
    }

    loadScript('https://www.youtube.com/iframe_api')
  }

  React.useEffect(() => {
    if (!ready || !player.getPlayerState) return

    let interval;

    if (player.getPlayerState() === YT.PlayerState.PLAYING) {
      const interval = setInterval(
        () => {
          const newCurrentTimestamp = getCurrentTimestamp(timestamps, player.getCurrentTime())
          setCurrentTimestamp(newCurrentTimestamp)
        },
        200
      )
    }

    return () => {
      clearInterval(interval)
    }
  }, [currentTimestamp?.id, ready, player?.getPlayerState ? player.getPlayerState() : null])

  return <>
    <iframe
      ref={iframeRef}
      id="cushvlog-player"
      className={`rounded-lg w-full h-full`}
      src={`${vlog.embed_link}?enablejsapi=1&controls=0&rel=0&seekTo=1&start=${parseInt(start)}&autoplay=${autoPlay ? 1: 0}`}
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen={0}
    />
    {showCaptions && currentTimestamp && <div className="absolute bottom-20 left-6 flex justify-center text-center">
      <div className="">
        <span className="bg-zinc-900/40 px-2 py-3 md:text-2xl inline">{currentTimestamp.transcription}</span>
      </div>
    </div>}
  </>
}